/**
 * @generated SignedSource<<5ef4127367b69f0ee8ac9145ef3c5884>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PermissionRules_node$data = {
  readonly isEvent: "Event";
  readonly isFolder: "Folder";
  readonly " $fragmentSpreads": FragmentRefs<"EventPermissionRules_event" | "FolderPermissionRules_folder" | "useNodeSecurity_node">;
  readonly " $fragmentType": "PermissionRules_node";
};
export type PermissionRules_node$key = {
  readonly " $data"?: PermissionRules_node$data;
  readonly " $fragmentSpreads": FragmentRefs<"PermissionRules_node">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PermissionRules_node",
  "selections": [
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "alias": "isEvent",
          "args": null,
          "kind": "ScalarField",
          "name": "__typename",
          "storageKey": null
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "EventPermissionRules_event"
        }
      ],
      "type": "Event",
      "abstractKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "alias": "isFolder",
          "args": null,
          "kind": "ScalarField",
          "name": "__typename",
          "storageKey": null
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "FolderPermissionRules_folder"
        }
      ],
      "type": "Folder",
      "abstractKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "useNodeSecurity_node"
    }
  ],
  "type": "Node",
  "abstractKey": "__isNode"
};

(node as any).hash = "e8c37b17bb2de17e51d0d860673379d5";

export default node;
